import { apiGet } from 'api';
import { GetAllParentOrganisationsResponse } from 'types';

export const getAllParentOrganisations = (): Promise<GetAllParentOrganisationsResponse> =>
  apiGet<GetAllParentOrganisationsResponse>('allparentorganisations');
